/* eslint-disable */
export function debounce(fn, delay) {
  // 记录上一次的延时器
  let timer = null;
  // eslint-disable-next-line no-var
  delay = delay || 200;
  return function () {
    const args = arguments;
    const that = this;
    // 清除上一次延时器
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

// 计算滚动的位置
export function pageScollY(e, r) {
  return e.reduce((e, c, n) => (n > 0 && n <= r && (e += c), e), 0);
};

// 获取元素子元素的高度
export const getNodeChildrenForOffsetHeight = e => { let t = [], o = e.children; for (let e = 0; e < o.length; e++) { const r = parseFloat(o[e].offsetHeight); t.push(r) } return t };

/*
    fn: 是真实处理事件的回调函数
    delay: 是节流时间段
*/
export function throttleStamp(t, n) { let e = Date.now(); return function () { var o = arguments; Date.now() - e >= n && (t.apply(this, o), e = Date.now()) } };

/*
    fn: 是真实处理事件的回调函数
    delay: 是节流时间段
*/
export function throttle(fn, delay) {
  // last为上一次触发回调的时间, timer是定时器
  let last = 0, timer = null;
  // 将throttle处理结果当作函数返回
  return function () {
    // 保留调用时的this上下文
    let context = this;
    // 保留调用时传入的参数
    let args = arguments;
    // 记录本次触发回调的时间
    let now = + new Date();
    // 判断上次触发的时间和本次触发的时间差是否小于时间间隔的阈值
    if (now - last < delay) {
      // 如果时间间隔小于我们设定的时间间隔阈值，则为本次触发操作设立一个新的定时器
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, delay);
    }
    else {
      // 如果时间间隔超出了我们设定的时间间隔阈值，那就不等了，无论如何要反馈给用户一次响应
      last = now;
      fn.apply(context, args);
    }
  };
}

// 去除首尾空格
export function trimStr(str) {
  return str.replace(/(^\s*)|(\s*$)/g, "");
}

// js 乘法函数
// 调用：accMul(arg1,arg2)
// 返回值：arg1乘以arg2的精确结果
export function accMul(arg1, arg2) {
  let m = 0;
  const s1 = arg1.toString();
  const s2 = arg2.toString();
  try {
    m += s1.split(".")[1] ? s1.split(".")[1].length : 0;
  } catch (e) {
    console.log(e);
  }
  try {
    m += s2.split(".")[1] ? s2.split(".")[1].length : 0;
  } catch (e) {
    console.log(e);
  }
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
}

/**
 * @description 不四舍五入取小数
 * @param num 数字
 * @param n 小数点位数
 */
export const toFixedDigit = (num, n) => {
  // 保留n位
  if (typeof num !== "number") {
    return false;
  }
  num = num.toString();
  let result = "";
  const zeroResult = function (n) {
    let zero = "";
    for (let i = 0; i < n; i++) {
      zero += "0";
    }
    return zero;
  };
  if (num % 1 === 0) {
    // 整数
    result = num + "." + zeroResult(n);
  } else {
    // 小数
    const num1 = num.split(".");
    if (num1[1].length < n) {
      result = num1[0] + "." + num1[1] + zeroResult(n - num1[1].length);
    } else {
      result = num1[0] + "." + num1[1].substring(0, n);
    }
  }
  return result;
};
